import { createActions } from 'redux-actions';

import types from 'state/mrCollection/extras/actionTypes';

const { mrCollection } = createActions({
  [types.SET_EXTRA]: (extra) => ({ extra }),
  [types.SET_EXTRAS]: (extras) => ({ extrasValues: extras }),
});

export default mrCollection;
